module.exports = __webpack_public_path__ + "img/cadreNormal.f54ae946.png";